const audioCache = new Map<string, HTMLAudioElement>();

function getAudio(src: string): HTMLAudioElement {
  let audio = audioCache.get(src);
  if (!audio) {
    audio = new Audio(src);
    audioCache.set(src, audio);
  }
  return audio;
}

export function playSound(src: string, volume = 0.5): void {
  try {
    const audio = getAudio(src);
    audio.volume = Math.min(1, Math.max(0, volume));
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch {
  }
}

export function preloadSound(src: string): void {
  getAudio(src);
}
